module.exports = __webpack_public_path__ + "static/img/skyline@2x.cb849dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2x/skyline@2x.png
// module id = 4pAi
// module chunks = 1